/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./../routes/__root"
import { Route as LoginRouteImport } from "./../routes/login"
import { Route as AuthRouteImport } from "./../routes/_auth"
import { Route as AuthIndexRouteImport } from "./../routes/_auth/index"
import { Route as AuthWasteNewRouteImport } from "./../routes/_auth/waste-new"
import { Route as AuthDriverRouteImport } from "./../routes/_auth/driver"
import { Route as AuthAdminRouteImport } from "./../routes/_auth/admin"
import { Route as AuthWasteSplitIdRouteImport } from "./../routes/_auth/waste-split.$id"
import { Route as AuthUploadShinwaJobRouteImport } from "./../routes/_auth/upload/shinwa-job"
import { Route as AuthTransferIdRouteImport } from "./../routes/_auth/transfer.$id"
import { Route as AuthSxferIdRouteImport } from "./../routes/_auth/sxfer.$id"
import { Route as AuthSelfTimelineRouteImport } from "./../routes/_auth/self/timeline"
import { Route as AuthSelfPrefsRouteImport } from "./../routes/_auth/self/prefs"
import { Route as AuthJobIdRouteImport } from "./../routes/_auth/job.$id"
import { Route as AuthDriverScheduleRouteImport } from "./../routes/_auth/driver/schedule"
import { Route as AuthDriverNextRouteImport } from "./../routes/_auth/driver/next"
import { Route as AuthDriverMyTruckRouteImport } from "./../routes/_auth/driver/my-truck"
import { Route as AuthDispatchTruckRouteImport } from "./../routes/_auth/dispatch/truck"
import { Route as AuthDispatchBundleRouteImport } from "./../routes/_auth/dispatch/bundle"
import { Route as AuthAdminWasteFlavorRouteImport } from "./../routes/_auth/admin/waste-flavor"
import { Route as AuthAdminSysconfRouteImport } from "./../routes/_auth/admin/sysconf"
import { Route as AuthAdminSanyuJobRouteImport } from "./../routes/_auth/admin/sanyu-job"
import { Route as AuthAdminRewindRouteImport } from "./../routes/_auth/admin/rewind"
import { Route as AuthAdminPackingModeRouteImport } from "./../routes/_auth/admin/packing-mode"
import { Route as AuthAdminOrphanedBundleRouteImport } from "./../routes/_auth/admin/orphaned-bundle"
import { Route as AuthAdminMastersRouteImport } from "./../routes/_auth/admin/masters"
import { Route as AuthAdminManifestTypeRouteImport } from "./../routes/_auth/admin/manifest-type"
import { Route as AuthAdminJobSpreadRouteImport } from "./../routes/_auth/admin/job-spread"
import { Route as AuthAdminJobExportRouteImport } from "./../routes/_auth/admin/job-export"
import { Route as AuthAdminDownstreamVenueRouteImport } from "./../routes/_auth/admin/downstream-venue"
import { Route as AuthAdminAgentRouteImport } from "./../routes/_auth/admin/agent"
import { Route as AuthAdminActiveAgentsRouteImport } from "./../routes/_auth/admin/active-agents"
import { Route as AuthVenueIdIndexRouteImport } from "./../routes/_auth/venue.$id/index"
import { Route as AuthCompanyIdIndexRouteImport } from "./../routes/_auth/company.$id/index"
import { Route as AuthWasteIdTimelineRouteImport } from "./../routes/_auth/waste.$id/timeline"
import { Route as AuthWasteIdCargoRouteImport } from "./../routes/_auth/waste.$id/cargo"
import { Route as AuthVenueIdServiceRouteImport } from "./../routes/_auth/venue.$id/service"
import { Route as AuthVenueIdGateRouteImport } from "./../routes/_auth/venue.$id/gate"
import { Route as AuthTruckIdTimelineRouteImport } from "./../routes/_auth/truck.$id/timeline"
import { Route as AuthTruckIdDriveRouteImport } from "./../routes/_auth/truck.$id/drive"
import { Route as AuthTruckIdCargoRouteImport } from "./../routes/_auth/truck.$id/cargo"
import { Route as AuthHistoryBundleIdRouteImport } from "./../routes/_auth/history/bundle.$id"
import { Route as AuthExportJobIdRouteImport } from "./../routes/_auth/export/job.$id"
import { Route as AuthExportBundleIdRouteImport } from "./../routes/_auth/export/bundle.$id"
import { Route as AuthBundleIdTimelineRouteImport } from "./../routes/_auth/bundle.$id/timeline"
import { Route as AuthBundleIdInspectRouteImport } from "./../routes/_auth/bundle.$id/inspect"
import { Route as AuthBundleIdCargoRouteImport } from "./../routes/_auth/bundle.$id/cargo"
import { Route as AuthAgentIdTimelineRouteImport } from "./../routes/_auth/agent.$id/timeline"
import { Route as AuthVenueIdSuperviseBundleRouteImport } from "./../routes/_auth/venue.$id/supervise/bundle"
import { Route as AuthVenueIdInspectWasteRouteImport } from "./../routes/_auth/venue.$id/inspect/waste"
import { Route as AuthVenueIdInspectBundleRouteImport } from "./../routes/_auth/venue.$id/inspect/bundle"
import { Route as AuthSurchargeScIdCargoRouteImport } from "./../routes/_auth/surcharge.$sc.$id/cargo"

const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: "/_auth",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthRoute,
} as any)
const AuthWasteNewRoute = AuthWasteNewRouteImport.update({
  id: "/waste-new",
  path: "/waste-new",
  getParentRoute: () => AuthRoute,
} as any)
const AuthDriverRoute = AuthDriverRouteImport.update({
  id: "/driver",
  path: "/driver",
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => AuthRoute,
} as any)
const AuthWasteSplitIdRoute = AuthWasteSplitIdRouteImport.update({
  id: "/waste-split/$id",
  path: "/waste-split/$id",
  getParentRoute: () => AuthRoute,
} as any)
const AuthUploadShinwaJobRoute = AuthUploadShinwaJobRouteImport.update({
  id: "/upload/shinwa-job",
  path: "/upload/shinwa-job",
  getParentRoute: () => AuthRoute,
} as any)
const AuthTransferIdRoute = AuthTransferIdRouteImport.update({
  id: "/transfer/$id",
  path: "/transfer/$id",
  getParentRoute: () => AuthRoute,
} as any)
const AuthSxferIdRoute = AuthSxferIdRouteImport.update({
  id: "/sxfer/$id",
  path: "/sxfer/$id",
  getParentRoute: () => AuthRoute,
} as any)
const AuthSelfTimelineRoute = AuthSelfTimelineRouteImport.update({
  id: "/self/timeline",
  path: "/self/timeline",
  getParentRoute: () => AuthRoute,
} as any)
const AuthSelfPrefsRoute = AuthSelfPrefsRouteImport.update({
  id: "/self/prefs",
  path: "/self/prefs",
  getParentRoute: () => AuthRoute,
} as any)
const AuthJobIdRoute = AuthJobIdRouteImport.update({
  id: "/job/$id",
  path: "/job/$id",
  getParentRoute: () => AuthRoute,
} as any)
const AuthDriverScheduleRoute = AuthDriverScheduleRouteImport.update({
  id: "/schedule",
  path: "/schedule",
  getParentRoute: () => AuthDriverRoute,
} as any)
const AuthDriverNextRoute = AuthDriverNextRouteImport.update({
  id: "/next",
  path: "/next",
  getParentRoute: () => AuthDriverRoute,
} as any)
const AuthDriverMyTruckRoute = AuthDriverMyTruckRouteImport.update({
  id: "/my-truck",
  path: "/my-truck",
  getParentRoute: () => AuthDriverRoute,
} as any)
const AuthDispatchTruckRoute = AuthDispatchTruckRouteImport.update({
  id: "/dispatch/truck",
  path: "/dispatch/truck",
  getParentRoute: () => AuthRoute,
} as any)
const AuthDispatchBundleRoute = AuthDispatchBundleRouteImport.update({
  id: "/dispatch/bundle",
  path: "/dispatch/bundle",
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminWasteFlavorRoute = AuthAdminWasteFlavorRouteImport.update({
  id: "/waste-flavor",
  path: "/waste-flavor",
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminSysconfRoute = AuthAdminSysconfRouteImport.update({
  id: "/sysconf",
  path: "/sysconf",
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminSanyuJobRoute = AuthAdminSanyuJobRouteImport.update({
  id: "/sanyu-job",
  path: "/sanyu-job",
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminRewindRoute = AuthAdminRewindRouteImport.update({
  id: "/rewind",
  path: "/rewind",
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminPackingModeRoute = AuthAdminPackingModeRouteImport.update({
  id: "/packing-mode",
  path: "/packing-mode",
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminOrphanedBundleRoute = AuthAdminOrphanedBundleRouteImport.update({
  id: "/orphaned-bundle",
  path: "/orphaned-bundle",
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminMastersRoute = AuthAdminMastersRouteImport.update({
  id: "/masters",
  path: "/masters",
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminManifestTypeRoute = AuthAdminManifestTypeRouteImport.update({
  id: "/manifest-type",
  path: "/manifest-type",
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminJobSpreadRoute = AuthAdminJobSpreadRouteImport.update({
  id: "/job-spread",
  path: "/job-spread",
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminJobExportRoute = AuthAdminJobExportRouteImport.update({
  id: "/job-export",
  path: "/job-export",
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminDownstreamVenueRoute =
  AuthAdminDownstreamVenueRouteImport.update({
    id: "/downstream-venue",
    path: "/downstream-venue",
    getParentRoute: () => AuthAdminRoute,
  } as any)
const AuthAdminAgentRoute = AuthAdminAgentRouteImport.update({
  id: "/agent",
  path: "/agent",
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminActiveAgentsRoute = AuthAdminActiveAgentsRouteImport.update({
  id: "/active-agents",
  path: "/active-agents",
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthVenueIdIndexRoute = AuthVenueIdIndexRouteImport.update({
  id: "/venue/$id/",
  path: "/venue/$id/",
  getParentRoute: () => AuthRoute,
} as any)
const AuthCompanyIdIndexRoute = AuthCompanyIdIndexRouteImport.update({
  id: "/company/$id/",
  path: "/company/$id/",
  getParentRoute: () => AuthRoute,
} as any)
const AuthWasteIdTimelineRoute = AuthWasteIdTimelineRouteImport.update({
  id: "/waste/$id/timeline",
  path: "/waste/$id/timeline",
  getParentRoute: () => AuthRoute,
} as any)
const AuthWasteIdCargoRoute = AuthWasteIdCargoRouteImport.update({
  id: "/waste/$id/cargo",
  path: "/waste/$id/cargo",
  getParentRoute: () => AuthRoute,
} as any)
const AuthVenueIdServiceRoute = AuthVenueIdServiceRouteImport.update({
  id: "/venue/$id/service",
  path: "/venue/$id/service",
  getParentRoute: () => AuthRoute,
} as any)
const AuthVenueIdGateRoute = AuthVenueIdGateRouteImport.update({
  id: "/venue/$id/gate",
  path: "/venue/$id/gate",
  getParentRoute: () => AuthRoute,
} as any)
const AuthTruckIdTimelineRoute = AuthTruckIdTimelineRouteImport.update({
  id: "/truck/$id/timeline",
  path: "/truck/$id/timeline",
  getParentRoute: () => AuthRoute,
} as any)
const AuthTruckIdDriveRoute = AuthTruckIdDriveRouteImport.update({
  id: "/truck/$id/drive",
  path: "/truck/$id/drive",
  getParentRoute: () => AuthRoute,
} as any)
const AuthTruckIdCargoRoute = AuthTruckIdCargoRouteImport.update({
  id: "/truck/$id/cargo",
  path: "/truck/$id/cargo",
  getParentRoute: () => AuthRoute,
} as any)
const AuthHistoryBundleIdRoute = AuthHistoryBundleIdRouteImport.update({
  id: "/history/bundle/$id",
  path: "/history/bundle/$id",
  getParentRoute: () => AuthRoute,
} as any)
const AuthExportJobIdRoute = AuthExportJobIdRouteImport.update({
  id: "/export/job/$id",
  path: "/export/job/$id",
  getParentRoute: () => AuthRoute,
} as any)
const AuthExportBundleIdRoute = AuthExportBundleIdRouteImport.update({
  id: "/export/bundle/$id",
  path: "/export/bundle/$id",
  getParentRoute: () => AuthRoute,
} as any)
const AuthBundleIdTimelineRoute = AuthBundleIdTimelineRouteImport.update({
  id: "/bundle/$id/timeline",
  path: "/bundle/$id/timeline",
  getParentRoute: () => AuthRoute,
} as any)
const AuthBundleIdInspectRoute = AuthBundleIdInspectRouteImport.update({
  id: "/bundle/$id/inspect",
  path: "/bundle/$id/inspect",
  getParentRoute: () => AuthRoute,
} as any)
const AuthBundleIdCargoRoute = AuthBundleIdCargoRouteImport.update({
  id: "/bundle/$id/cargo",
  path: "/bundle/$id/cargo",
  getParentRoute: () => AuthRoute,
} as any)
const AuthAgentIdTimelineRoute = AuthAgentIdTimelineRouteImport.update({
  id: "/agent/$id/timeline",
  path: "/agent/$id/timeline",
  getParentRoute: () => AuthRoute,
} as any)
const AuthVenueIdSuperviseBundleRoute =
  AuthVenueIdSuperviseBundleRouteImport.update({
    id: "/venue/$id/supervise/bundle",
    path: "/venue/$id/supervise/bundle",
    getParentRoute: () => AuthRoute,
  } as any)
const AuthVenueIdInspectWasteRoute = AuthVenueIdInspectWasteRouteImport.update({
  id: "/venue/$id/inspect/waste",
  path: "/venue/$id/inspect/waste",
  getParentRoute: () => AuthRoute,
} as any)
const AuthVenueIdInspectBundleRoute =
  AuthVenueIdInspectBundleRouteImport.update({
    id: "/venue/$id/inspect/bundle",
    path: "/venue/$id/inspect/bundle",
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSurchargeScIdCargoRoute = AuthSurchargeScIdCargoRouteImport.update({
  id: "/surcharge/$sc/$id/cargo",
  path: "/surcharge/$sc/$id/cargo",
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  "/login": typeof LoginRoute
  "/admin": typeof AuthAdminRouteWithChildren
  "/driver": typeof AuthDriverRouteWithChildren
  "/waste-new": typeof AuthWasteNewRoute
  "/": typeof AuthIndexRoute
  "/admin/active-agents": typeof AuthAdminActiveAgentsRoute
  "/admin/agent": typeof AuthAdminAgentRoute
  "/admin/downstream-venue": typeof AuthAdminDownstreamVenueRoute
  "/admin/job-export": typeof AuthAdminJobExportRoute
  "/admin/job-spread": typeof AuthAdminJobSpreadRoute
  "/admin/manifest-type": typeof AuthAdminManifestTypeRoute
  "/admin/masters": typeof AuthAdminMastersRoute
  "/admin/orphaned-bundle": typeof AuthAdminOrphanedBundleRoute
  "/admin/packing-mode": typeof AuthAdminPackingModeRoute
  "/admin/rewind": typeof AuthAdminRewindRoute
  "/admin/sanyu-job": typeof AuthAdminSanyuJobRoute
  "/admin/sysconf": typeof AuthAdminSysconfRoute
  "/admin/waste-flavor": typeof AuthAdminWasteFlavorRoute
  "/dispatch/bundle": typeof AuthDispatchBundleRoute
  "/dispatch/truck": typeof AuthDispatchTruckRoute
  "/driver/my-truck": typeof AuthDriverMyTruckRoute
  "/driver/next": typeof AuthDriverNextRoute
  "/driver/schedule": typeof AuthDriverScheduleRoute
  "/job/$id": typeof AuthJobIdRoute
  "/self/prefs": typeof AuthSelfPrefsRoute
  "/self/timeline": typeof AuthSelfTimelineRoute
  "/sxfer/$id": typeof AuthSxferIdRoute
  "/transfer/$id": typeof AuthTransferIdRoute
  "/upload/shinwa-job": typeof AuthUploadShinwaJobRoute
  "/waste-split/$id": typeof AuthWasteSplitIdRoute
  "/agent/$id/timeline": typeof AuthAgentIdTimelineRoute
  "/bundle/$id/cargo": typeof AuthBundleIdCargoRoute
  "/bundle/$id/inspect": typeof AuthBundleIdInspectRoute
  "/bundle/$id/timeline": typeof AuthBundleIdTimelineRoute
  "/export/bundle/$id": typeof AuthExportBundleIdRoute
  "/export/job/$id": typeof AuthExportJobIdRoute
  "/history/bundle/$id": typeof AuthHistoryBundleIdRoute
  "/truck/$id/cargo": typeof AuthTruckIdCargoRoute
  "/truck/$id/drive": typeof AuthTruckIdDriveRoute
  "/truck/$id/timeline": typeof AuthTruckIdTimelineRoute
  "/venue/$id/gate": typeof AuthVenueIdGateRoute
  "/venue/$id/service": typeof AuthVenueIdServiceRoute
  "/waste/$id/cargo": typeof AuthWasteIdCargoRoute
  "/waste/$id/timeline": typeof AuthWasteIdTimelineRoute
  "/company/$id": typeof AuthCompanyIdIndexRoute
  "/venue/$id": typeof AuthVenueIdIndexRoute
  "/surcharge/$sc/$id/cargo": typeof AuthSurchargeScIdCargoRoute
  "/venue/$id/inspect/bundle": typeof AuthVenueIdInspectBundleRoute
  "/venue/$id/inspect/waste": typeof AuthVenueIdInspectWasteRoute
  "/venue/$id/supervise/bundle": typeof AuthVenueIdSuperviseBundleRoute
}
export interface FileRoutesByTo {
  "/login": typeof LoginRoute
  "/admin": typeof AuthAdminRouteWithChildren
  "/driver": typeof AuthDriverRouteWithChildren
  "/waste-new": typeof AuthWasteNewRoute
  "/": typeof AuthIndexRoute
  "/admin/active-agents": typeof AuthAdminActiveAgentsRoute
  "/admin/agent": typeof AuthAdminAgentRoute
  "/admin/downstream-venue": typeof AuthAdminDownstreamVenueRoute
  "/admin/job-export": typeof AuthAdminJobExportRoute
  "/admin/job-spread": typeof AuthAdminJobSpreadRoute
  "/admin/manifest-type": typeof AuthAdminManifestTypeRoute
  "/admin/masters": typeof AuthAdminMastersRoute
  "/admin/orphaned-bundle": typeof AuthAdminOrphanedBundleRoute
  "/admin/packing-mode": typeof AuthAdminPackingModeRoute
  "/admin/rewind": typeof AuthAdminRewindRoute
  "/admin/sanyu-job": typeof AuthAdminSanyuJobRoute
  "/admin/sysconf": typeof AuthAdminSysconfRoute
  "/admin/waste-flavor": typeof AuthAdminWasteFlavorRoute
  "/dispatch/bundle": typeof AuthDispatchBundleRoute
  "/dispatch/truck": typeof AuthDispatchTruckRoute
  "/driver/my-truck": typeof AuthDriverMyTruckRoute
  "/driver/next": typeof AuthDriverNextRoute
  "/driver/schedule": typeof AuthDriverScheduleRoute
  "/job/$id": typeof AuthJobIdRoute
  "/self/prefs": typeof AuthSelfPrefsRoute
  "/self/timeline": typeof AuthSelfTimelineRoute
  "/sxfer/$id": typeof AuthSxferIdRoute
  "/transfer/$id": typeof AuthTransferIdRoute
  "/upload/shinwa-job": typeof AuthUploadShinwaJobRoute
  "/waste-split/$id": typeof AuthWasteSplitIdRoute
  "/agent/$id/timeline": typeof AuthAgentIdTimelineRoute
  "/bundle/$id/cargo": typeof AuthBundleIdCargoRoute
  "/bundle/$id/inspect": typeof AuthBundleIdInspectRoute
  "/bundle/$id/timeline": typeof AuthBundleIdTimelineRoute
  "/export/bundle/$id": typeof AuthExportBundleIdRoute
  "/export/job/$id": typeof AuthExportJobIdRoute
  "/history/bundle/$id": typeof AuthHistoryBundleIdRoute
  "/truck/$id/cargo": typeof AuthTruckIdCargoRoute
  "/truck/$id/drive": typeof AuthTruckIdDriveRoute
  "/truck/$id/timeline": typeof AuthTruckIdTimelineRoute
  "/venue/$id/gate": typeof AuthVenueIdGateRoute
  "/venue/$id/service": typeof AuthVenueIdServiceRoute
  "/waste/$id/cargo": typeof AuthWasteIdCargoRoute
  "/waste/$id/timeline": typeof AuthWasteIdTimelineRoute
  "/company/$id": typeof AuthCompanyIdIndexRoute
  "/venue/$id": typeof AuthVenueIdIndexRoute
  "/surcharge/$sc/$id/cargo": typeof AuthSurchargeScIdCargoRoute
  "/venue/$id/inspect/bundle": typeof AuthVenueIdInspectBundleRoute
  "/venue/$id/inspect/waste": typeof AuthVenueIdInspectWasteRoute
  "/venue/$id/supervise/bundle": typeof AuthVenueIdSuperviseBundleRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_auth": typeof AuthRouteWithChildren
  "/login": typeof LoginRoute
  "/_auth/admin": typeof AuthAdminRouteWithChildren
  "/_auth/driver": typeof AuthDriverRouteWithChildren
  "/_auth/waste-new": typeof AuthWasteNewRoute
  "/_auth/": typeof AuthIndexRoute
  "/_auth/admin/active-agents": typeof AuthAdminActiveAgentsRoute
  "/_auth/admin/agent": typeof AuthAdminAgentRoute
  "/_auth/admin/downstream-venue": typeof AuthAdminDownstreamVenueRoute
  "/_auth/admin/job-export": typeof AuthAdminJobExportRoute
  "/_auth/admin/job-spread": typeof AuthAdminJobSpreadRoute
  "/_auth/admin/manifest-type": typeof AuthAdminManifestTypeRoute
  "/_auth/admin/masters": typeof AuthAdminMastersRoute
  "/_auth/admin/orphaned-bundle": typeof AuthAdminOrphanedBundleRoute
  "/_auth/admin/packing-mode": typeof AuthAdminPackingModeRoute
  "/_auth/admin/rewind": typeof AuthAdminRewindRoute
  "/_auth/admin/sanyu-job": typeof AuthAdminSanyuJobRoute
  "/_auth/admin/sysconf": typeof AuthAdminSysconfRoute
  "/_auth/admin/waste-flavor": typeof AuthAdminWasteFlavorRoute
  "/_auth/dispatch/bundle": typeof AuthDispatchBundleRoute
  "/_auth/dispatch/truck": typeof AuthDispatchTruckRoute
  "/_auth/driver/my-truck": typeof AuthDriverMyTruckRoute
  "/_auth/driver/next": typeof AuthDriverNextRoute
  "/_auth/driver/schedule": typeof AuthDriverScheduleRoute
  "/_auth/job/$id": typeof AuthJobIdRoute
  "/_auth/self/prefs": typeof AuthSelfPrefsRoute
  "/_auth/self/timeline": typeof AuthSelfTimelineRoute
  "/_auth/sxfer/$id": typeof AuthSxferIdRoute
  "/_auth/transfer/$id": typeof AuthTransferIdRoute
  "/_auth/upload/shinwa-job": typeof AuthUploadShinwaJobRoute
  "/_auth/waste-split/$id": typeof AuthWasteSplitIdRoute
  "/_auth/agent/$id/timeline": typeof AuthAgentIdTimelineRoute
  "/_auth/bundle/$id/cargo": typeof AuthBundleIdCargoRoute
  "/_auth/bundle/$id/inspect": typeof AuthBundleIdInspectRoute
  "/_auth/bundle/$id/timeline": typeof AuthBundleIdTimelineRoute
  "/_auth/export/bundle/$id": typeof AuthExportBundleIdRoute
  "/_auth/export/job/$id": typeof AuthExportJobIdRoute
  "/_auth/history/bundle/$id": typeof AuthHistoryBundleIdRoute
  "/_auth/truck/$id/cargo": typeof AuthTruckIdCargoRoute
  "/_auth/truck/$id/drive": typeof AuthTruckIdDriveRoute
  "/_auth/truck/$id/timeline": typeof AuthTruckIdTimelineRoute
  "/_auth/venue/$id/gate": typeof AuthVenueIdGateRoute
  "/_auth/venue/$id/service": typeof AuthVenueIdServiceRoute
  "/_auth/waste/$id/cargo": typeof AuthWasteIdCargoRoute
  "/_auth/waste/$id/timeline": typeof AuthWasteIdTimelineRoute
  "/_auth/company/$id/": typeof AuthCompanyIdIndexRoute
  "/_auth/venue/$id/": typeof AuthVenueIdIndexRoute
  "/_auth/surcharge/$sc/$id/cargo": typeof AuthSurchargeScIdCargoRoute
  "/_auth/venue/$id/inspect/bundle": typeof AuthVenueIdInspectBundleRoute
  "/_auth/venue/$id/inspect/waste": typeof AuthVenueIdInspectWasteRoute
  "/_auth/venue/$id/supervise/bundle": typeof AuthVenueIdSuperviseBundleRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/login"
    | "/admin"
    | "/driver"
    | "/waste-new"
    | "/"
    | "/admin/active-agents"
    | "/admin/agent"
    | "/admin/downstream-venue"
    | "/admin/job-export"
    | "/admin/job-spread"
    | "/admin/manifest-type"
    | "/admin/masters"
    | "/admin/orphaned-bundle"
    | "/admin/packing-mode"
    | "/admin/rewind"
    | "/admin/sanyu-job"
    | "/admin/sysconf"
    | "/admin/waste-flavor"
    | "/dispatch/bundle"
    | "/dispatch/truck"
    | "/driver/my-truck"
    | "/driver/next"
    | "/driver/schedule"
    | "/job/$id"
    | "/self/prefs"
    | "/self/timeline"
    | "/sxfer/$id"
    | "/transfer/$id"
    | "/upload/shinwa-job"
    | "/waste-split/$id"
    | "/agent/$id/timeline"
    | "/bundle/$id/cargo"
    | "/bundle/$id/inspect"
    | "/bundle/$id/timeline"
    | "/export/bundle/$id"
    | "/export/job/$id"
    | "/history/bundle/$id"
    | "/truck/$id/cargo"
    | "/truck/$id/drive"
    | "/truck/$id/timeline"
    | "/venue/$id/gate"
    | "/venue/$id/service"
    | "/waste/$id/cargo"
    | "/waste/$id/timeline"
    | "/company/$id"
    | "/venue/$id"
    | "/surcharge/$sc/$id/cargo"
    | "/venue/$id/inspect/bundle"
    | "/venue/$id/inspect/waste"
    | "/venue/$id/supervise/bundle"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/login"
    | "/admin"
    | "/driver"
    | "/waste-new"
    | "/"
    | "/admin/active-agents"
    | "/admin/agent"
    | "/admin/downstream-venue"
    | "/admin/job-export"
    | "/admin/job-spread"
    | "/admin/manifest-type"
    | "/admin/masters"
    | "/admin/orphaned-bundle"
    | "/admin/packing-mode"
    | "/admin/rewind"
    | "/admin/sanyu-job"
    | "/admin/sysconf"
    | "/admin/waste-flavor"
    | "/dispatch/bundle"
    | "/dispatch/truck"
    | "/driver/my-truck"
    | "/driver/next"
    | "/driver/schedule"
    | "/job/$id"
    | "/self/prefs"
    | "/self/timeline"
    | "/sxfer/$id"
    | "/transfer/$id"
    | "/upload/shinwa-job"
    | "/waste-split/$id"
    | "/agent/$id/timeline"
    | "/bundle/$id/cargo"
    | "/bundle/$id/inspect"
    | "/bundle/$id/timeline"
    | "/export/bundle/$id"
    | "/export/job/$id"
    | "/history/bundle/$id"
    | "/truck/$id/cargo"
    | "/truck/$id/drive"
    | "/truck/$id/timeline"
    | "/venue/$id/gate"
    | "/venue/$id/service"
    | "/waste/$id/cargo"
    | "/waste/$id/timeline"
    | "/company/$id"
    | "/venue/$id"
    | "/surcharge/$sc/$id/cargo"
    | "/venue/$id/inspect/bundle"
    | "/venue/$id/inspect/waste"
    | "/venue/$id/supervise/bundle"
  id:
    | "__root__"
    | "/_auth"
    | "/login"
    | "/_auth/admin"
    | "/_auth/driver"
    | "/_auth/waste-new"
    | "/_auth/"
    | "/_auth/admin/active-agents"
    | "/_auth/admin/agent"
    | "/_auth/admin/downstream-venue"
    | "/_auth/admin/job-export"
    | "/_auth/admin/job-spread"
    | "/_auth/admin/manifest-type"
    | "/_auth/admin/masters"
    | "/_auth/admin/orphaned-bundle"
    | "/_auth/admin/packing-mode"
    | "/_auth/admin/rewind"
    | "/_auth/admin/sanyu-job"
    | "/_auth/admin/sysconf"
    | "/_auth/admin/waste-flavor"
    | "/_auth/dispatch/bundle"
    | "/_auth/dispatch/truck"
    | "/_auth/driver/my-truck"
    | "/_auth/driver/next"
    | "/_auth/driver/schedule"
    | "/_auth/job/$id"
    | "/_auth/self/prefs"
    | "/_auth/self/timeline"
    | "/_auth/sxfer/$id"
    | "/_auth/transfer/$id"
    | "/_auth/upload/shinwa-job"
    | "/_auth/waste-split/$id"
    | "/_auth/agent/$id/timeline"
    | "/_auth/bundle/$id/cargo"
    | "/_auth/bundle/$id/inspect"
    | "/_auth/bundle/$id/timeline"
    | "/_auth/export/bundle/$id"
    | "/_auth/export/job/$id"
    | "/_auth/history/bundle/$id"
    | "/_auth/truck/$id/cargo"
    | "/_auth/truck/$id/drive"
    | "/_auth/truck/$id/timeline"
    | "/_auth/venue/$id/gate"
    | "/_auth/venue/$id/service"
    | "/_auth/waste/$id/cargo"
    | "/_auth/waste/$id/timeline"
    | "/_auth/company/$id/"
    | "/_auth/venue/$id/"
    | "/_auth/surcharge/$sc/$id/cargo"
    | "/_auth/venue/$id/inspect/bundle"
    | "/_auth/venue/$id/inspect/waste"
    | "/_auth/venue/$id/supervise/bundle"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_auth": {
      id: "/_auth"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_auth/": {
      id: "/_auth/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/waste-new": {
      id: "/_auth/waste-new"
      path: "/waste-new"
      fullPath: "/waste-new"
      preLoaderRoute: typeof AuthWasteNewRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/driver": {
      id: "/_auth/driver"
      path: "/driver"
      fullPath: "/driver"
      preLoaderRoute: typeof AuthDriverRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/admin": {
      id: "/_auth/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/waste-split/$id": {
      id: "/_auth/waste-split/$id"
      path: "/waste-split/$id"
      fullPath: "/waste-split/$id"
      preLoaderRoute: typeof AuthWasteSplitIdRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/upload/shinwa-job": {
      id: "/_auth/upload/shinwa-job"
      path: "/upload/shinwa-job"
      fullPath: "/upload/shinwa-job"
      preLoaderRoute: typeof AuthUploadShinwaJobRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/transfer/$id": {
      id: "/_auth/transfer/$id"
      path: "/transfer/$id"
      fullPath: "/transfer/$id"
      preLoaderRoute: typeof AuthTransferIdRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/sxfer/$id": {
      id: "/_auth/sxfer/$id"
      path: "/sxfer/$id"
      fullPath: "/sxfer/$id"
      preLoaderRoute: typeof AuthSxferIdRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/self/timeline": {
      id: "/_auth/self/timeline"
      path: "/self/timeline"
      fullPath: "/self/timeline"
      preLoaderRoute: typeof AuthSelfTimelineRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/self/prefs": {
      id: "/_auth/self/prefs"
      path: "/self/prefs"
      fullPath: "/self/prefs"
      preLoaderRoute: typeof AuthSelfPrefsRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/job/$id": {
      id: "/_auth/job/$id"
      path: "/job/$id"
      fullPath: "/job/$id"
      preLoaderRoute: typeof AuthJobIdRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/driver/schedule": {
      id: "/_auth/driver/schedule"
      path: "/schedule"
      fullPath: "/driver/schedule"
      preLoaderRoute: typeof AuthDriverScheduleRouteImport
      parentRoute: typeof AuthDriverRoute
    }
    "/_auth/driver/next": {
      id: "/_auth/driver/next"
      path: "/next"
      fullPath: "/driver/next"
      preLoaderRoute: typeof AuthDriverNextRouteImport
      parentRoute: typeof AuthDriverRoute
    }
    "/_auth/driver/my-truck": {
      id: "/_auth/driver/my-truck"
      path: "/my-truck"
      fullPath: "/driver/my-truck"
      preLoaderRoute: typeof AuthDriverMyTruckRouteImport
      parentRoute: typeof AuthDriverRoute
    }
    "/_auth/dispatch/truck": {
      id: "/_auth/dispatch/truck"
      path: "/dispatch/truck"
      fullPath: "/dispatch/truck"
      preLoaderRoute: typeof AuthDispatchTruckRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/dispatch/bundle": {
      id: "/_auth/dispatch/bundle"
      path: "/dispatch/bundle"
      fullPath: "/dispatch/bundle"
      preLoaderRoute: typeof AuthDispatchBundleRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/admin/waste-flavor": {
      id: "/_auth/admin/waste-flavor"
      path: "/waste-flavor"
      fullPath: "/admin/waste-flavor"
      preLoaderRoute: typeof AuthAdminWasteFlavorRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/admin/sysconf": {
      id: "/_auth/admin/sysconf"
      path: "/sysconf"
      fullPath: "/admin/sysconf"
      preLoaderRoute: typeof AuthAdminSysconfRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/admin/sanyu-job": {
      id: "/_auth/admin/sanyu-job"
      path: "/sanyu-job"
      fullPath: "/admin/sanyu-job"
      preLoaderRoute: typeof AuthAdminSanyuJobRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/admin/rewind": {
      id: "/_auth/admin/rewind"
      path: "/rewind"
      fullPath: "/admin/rewind"
      preLoaderRoute: typeof AuthAdminRewindRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/admin/packing-mode": {
      id: "/_auth/admin/packing-mode"
      path: "/packing-mode"
      fullPath: "/admin/packing-mode"
      preLoaderRoute: typeof AuthAdminPackingModeRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/admin/orphaned-bundle": {
      id: "/_auth/admin/orphaned-bundle"
      path: "/orphaned-bundle"
      fullPath: "/admin/orphaned-bundle"
      preLoaderRoute: typeof AuthAdminOrphanedBundleRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/admin/masters": {
      id: "/_auth/admin/masters"
      path: "/masters"
      fullPath: "/admin/masters"
      preLoaderRoute: typeof AuthAdminMastersRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/admin/manifest-type": {
      id: "/_auth/admin/manifest-type"
      path: "/manifest-type"
      fullPath: "/admin/manifest-type"
      preLoaderRoute: typeof AuthAdminManifestTypeRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/admin/job-spread": {
      id: "/_auth/admin/job-spread"
      path: "/job-spread"
      fullPath: "/admin/job-spread"
      preLoaderRoute: typeof AuthAdminJobSpreadRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/admin/job-export": {
      id: "/_auth/admin/job-export"
      path: "/job-export"
      fullPath: "/admin/job-export"
      preLoaderRoute: typeof AuthAdminJobExportRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/admin/downstream-venue": {
      id: "/_auth/admin/downstream-venue"
      path: "/downstream-venue"
      fullPath: "/admin/downstream-venue"
      preLoaderRoute: typeof AuthAdminDownstreamVenueRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/admin/agent": {
      id: "/_auth/admin/agent"
      path: "/agent"
      fullPath: "/admin/agent"
      preLoaderRoute: typeof AuthAdminAgentRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/admin/active-agents": {
      id: "/_auth/admin/active-agents"
      path: "/active-agents"
      fullPath: "/admin/active-agents"
      preLoaderRoute: typeof AuthAdminActiveAgentsRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    "/_auth/venue/$id/": {
      id: "/_auth/venue/$id/"
      path: "/venue/$id"
      fullPath: "/venue/$id"
      preLoaderRoute: typeof AuthVenueIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/company/$id/": {
      id: "/_auth/company/$id/"
      path: "/company/$id"
      fullPath: "/company/$id"
      preLoaderRoute: typeof AuthCompanyIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/waste/$id/timeline": {
      id: "/_auth/waste/$id/timeline"
      path: "/waste/$id/timeline"
      fullPath: "/waste/$id/timeline"
      preLoaderRoute: typeof AuthWasteIdTimelineRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/waste/$id/cargo": {
      id: "/_auth/waste/$id/cargo"
      path: "/waste/$id/cargo"
      fullPath: "/waste/$id/cargo"
      preLoaderRoute: typeof AuthWasteIdCargoRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/venue/$id/service": {
      id: "/_auth/venue/$id/service"
      path: "/venue/$id/service"
      fullPath: "/venue/$id/service"
      preLoaderRoute: typeof AuthVenueIdServiceRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/venue/$id/gate": {
      id: "/_auth/venue/$id/gate"
      path: "/venue/$id/gate"
      fullPath: "/venue/$id/gate"
      preLoaderRoute: typeof AuthVenueIdGateRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/truck/$id/timeline": {
      id: "/_auth/truck/$id/timeline"
      path: "/truck/$id/timeline"
      fullPath: "/truck/$id/timeline"
      preLoaderRoute: typeof AuthTruckIdTimelineRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/truck/$id/drive": {
      id: "/_auth/truck/$id/drive"
      path: "/truck/$id/drive"
      fullPath: "/truck/$id/drive"
      preLoaderRoute: typeof AuthTruckIdDriveRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/truck/$id/cargo": {
      id: "/_auth/truck/$id/cargo"
      path: "/truck/$id/cargo"
      fullPath: "/truck/$id/cargo"
      preLoaderRoute: typeof AuthTruckIdCargoRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/history/bundle/$id": {
      id: "/_auth/history/bundle/$id"
      path: "/history/bundle/$id"
      fullPath: "/history/bundle/$id"
      preLoaderRoute: typeof AuthHistoryBundleIdRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/export/job/$id": {
      id: "/_auth/export/job/$id"
      path: "/export/job/$id"
      fullPath: "/export/job/$id"
      preLoaderRoute: typeof AuthExportJobIdRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/export/bundle/$id": {
      id: "/_auth/export/bundle/$id"
      path: "/export/bundle/$id"
      fullPath: "/export/bundle/$id"
      preLoaderRoute: typeof AuthExportBundleIdRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/bundle/$id/timeline": {
      id: "/_auth/bundle/$id/timeline"
      path: "/bundle/$id/timeline"
      fullPath: "/bundle/$id/timeline"
      preLoaderRoute: typeof AuthBundleIdTimelineRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/bundle/$id/inspect": {
      id: "/_auth/bundle/$id/inspect"
      path: "/bundle/$id/inspect"
      fullPath: "/bundle/$id/inspect"
      preLoaderRoute: typeof AuthBundleIdInspectRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/bundle/$id/cargo": {
      id: "/_auth/bundle/$id/cargo"
      path: "/bundle/$id/cargo"
      fullPath: "/bundle/$id/cargo"
      preLoaderRoute: typeof AuthBundleIdCargoRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/agent/$id/timeline": {
      id: "/_auth/agent/$id/timeline"
      path: "/agent/$id/timeline"
      fullPath: "/agent/$id/timeline"
      preLoaderRoute: typeof AuthAgentIdTimelineRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/venue/$id/supervise/bundle": {
      id: "/_auth/venue/$id/supervise/bundle"
      path: "/venue/$id/supervise/bundle"
      fullPath: "/venue/$id/supervise/bundle"
      preLoaderRoute: typeof AuthVenueIdSuperviseBundleRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/venue/$id/inspect/waste": {
      id: "/_auth/venue/$id/inspect/waste"
      path: "/venue/$id/inspect/waste"
      fullPath: "/venue/$id/inspect/waste"
      preLoaderRoute: typeof AuthVenueIdInspectWasteRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/venue/$id/inspect/bundle": {
      id: "/_auth/venue/$id/inspect/bundle"
      path: "/venue/$id/inspect/bundle"
      fullPath: "/venue/$id/inspect/bundle"
      preLoaderRoute: typeof AuthVenueIdInspectBundleRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/surcharge/$sc/$id/cargo": {
      id: "/_auth/surcharge/$sc/$id/cargo"
      path: "/surcharge/$sc/$id/cargo"
      fullPath: "/surcharge/$sc/$id/cargo"
      preLoaderRoute: typeof AuthSurchargeScIdCargoRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthAdminRouteChildren {
  AuthAdminActiveAgentsRoute: typeof AuthAdminActiveAgentsRoute
  AuthAdminAgentRoute: typeof AuthAdminAgentRoute
  AuthAdminDownstreamVenueRoute: typeof AuthAdminDownstreamVenueRoute
  AuthAdminJobExportRoute: typeof AuthAdminJobExportRoute
  AuthAdminJobSpreadRoute: typeof AuthAdminJobSpreadRoute
  AuthAdminManifestTypeRoute: typeof AuthAdminManifestTypeRoute
  AuthAdminMastersRoute: typeof AuthAdminMastersRoute
  AuthAdminOrphanedBundleRoute: typeof AuthAdminOrphanedBundleRoute
  AuthAdminPackingModeRoute: typeof AuthAdminPackingModeRoute
  AuthAdminRewindRoute: typeof AuthAdminRewindRoute
  AuthAdminSanyuJobRoute: typeof AuthAdminSanyuJobRoute
  AuthAdminSysconfRoute: typeof AuthAdminSysconfRoute
  AuthAdminWasteFlavorRoute: typeof AuthAdminWasteFlavorRoute
}

const AuthAdminRouteChildren: AuthAdminRouteChildren = {
  AuthAdminActiveAgentsRoute: AuthAdminActiveAgentsRoute,
  AuthAdminAgentRoute: AuthAdminAgentRoute,
  AuthAdminDownstreamVenueRoute: AuthAdminDownstreamVenueRoute,
  AuthAdminJobExportRoute: AuthAdminJobExportRoute,
  AuthAdminJobSpreadRoute: AuthAdminJobSpreadRoute,
  AuthAdminManifestTypeRoute: AuthAdminManifestTypeRoute,
  AuthAdminMastersRoute: AuthAdminMastersRoute,
  AuthAdminOrphanedBundleRoute: AuthAdminOrphanedBundleRoute,
  AuthAdminPackingModeRoute: AuthAdminPackingModeRoute,
  AuthAdminRewindRoute: AuthAdminRewindRoute,
  AuthAdminSanyuJobRoute: AuthAdminSanyuJobRoute,
  AuthAdminSysconfRoute: AuthAdminSysconfRoute,
  AuthAdminWasteFlavorRoute: AuthAdminWasteFlavorRoute,
}

const AuthAdminRouteWithChildren = AuthAdminRoute._addFileChildren(
  AuthAdminRouteChildren,
)

interface AuthDriverRouteChildren {
  AuthDriverMyTruckRoute: typeof AuthDriverMyTruckRoute
  AuthDriverNextRoute: typeof AuthDriverNextRoute
  AuthDriverScheduleRoute: typeof AuthDriverScheduleRoute
}

const AuthDriverRouteChildren: AuthDriverRouteChildren = {
  AuthDriverMyTruckRoute: AuthDriverMyTruckRoute,
  AuthDriverNextRoute: AuthDriverNextRoute,
  AuthDriverScheduleRoute: AuthDriverScheduleRoute,
}

const AuthDriverRouteWithChildren = AuthDriverRoute._addFileChildren(
  AuthDriverRouteChildren,
)

interface AuthRouteChildren {
  AuthAdminRoute: typeof AuthAdminRouteWithChildren
  AuthDriverRoute: typeof AuthDriverRouteWithChildren
  AuthWasteNewRoute: typeof AuthWasteNewRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthDispatchBundleRoute: typeof AuthDispatchBundleRoute
  AuthDispatchTruckRoute: typeof AuthDispatchTruckRoute
  AuthJobIdRoute: typeof AuthJobIdRoute
  AuthSelfPrefsRoute: typeof AuthSelfPrefsRoute
  AuthSelfTimelineRoute: typeof AuthSelfTimelineRoute
  AuthSxferIdRoute: typeof AuthSxferIdRoute
  AuthTransferIdRoute: typeof AuthTransferIdRoute
  AuthUploadShinwaJobRoute: typeof AuthUploadShinwaJobRoute
  AuthWasteSplitIdRoute: typeof AuthWasteSplitIdRoute
  AuthAgentIdTimelineRoute: typeof AuthAgentIdTimelineRoute
  AuthBundleIdCargoRoute: typeof AuthBundleIdCargoRoute
  AuthBundleIdInspectRoute: typeof AuthBundleIdInspectRoute
  AuthBundleIdTimelineRoute: typeof AuthBundleIdTimelineRoute
  AuthExportBundleIdRoute: typeof AuthExportBundleIdRoute
  AuthExportJobIdRoute: typeof AuthExportJobIdRoute
  AuthHistoryBundleIdRoute: typeof AuthHistoryBundleIdRoute
  AuthTruckIdCargoRoute: typeof AuthTruckIdCargoRoute
  AuthTruckIdDriveRoute: typeof AuthTruckIdDriveRoute
  AuthTruckIdTimelineRoute: typeof AuthTruckIdTimelineRoute
  AuthVenueIdGateRoute: typeof AuthVenueIdGateRoute
  AuthVenueIdServiceRoute: typeof AuthVenueIdServiceRoute
  AuthWasteIdCargoRoute: typeof AuthWasteIdCargoRoute
  AuthWasteIdTimelineRoute: typeof AuthWasteIdTimelineRoute
  AuthCompanyIdIndexRoute: typeof AuthCompanyIdIndexRoute
  AuthVenueIdIndexRoute: typeof AuthVenueIdIndexRoute
  AuthSurchargeScIdCargoRoute: typeof AuthSurchargeScIdCargoRoute
  AuthVenueIdInspectBundleRoute: typeof AuthVenueIdInspectBundleRoute
  AuthVenueIdInspectWasteRoute: typeof AuthVenueIdInspectWasteRoute
  AuthVenueIdSuperviseBundleRoute: typeof AuthVenueIdSuperviseBundleRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAdminRoute: AuthAdminRouteWithChildren,
  AuthDriverRoute: AuthDriverRouteWithChildren,
  AuthWasteNewRoute: AuthWasteNewRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthDispatchBundleRoute: AuthDispatchBundleRoute,
  AuthDispatchTruckRoute: AuthDispatchTruckRoute,
  AuthJobIdRoute: AuthJobIdRoute,
  AuthSelfPrefsRoute: AuthSelfPrefsRoute,
  AuthSelfTimelineRoute: AuthSelfTimelineRoute,
  AuthSxferIdRoute: AuthSxferIdRoute,
  AuthTransferIdRoute: AuthTransferIdRoute,
  AuthUploadShinwaJobRoute: AuthUploadShinwaJobRoute,
  AuthWasteSplitIdRoute: AuthWasteSplitIdRoute,
  AuthAgentIdTimelineRoute: AuthAgentIdTimelineRoute,
  AuthBundleIdCargoRoute: AuthBundleIdCargoRoute,
  AuthBundleIdInspectRoute: AuthBundleIdInspectRoute,
  AuthBundleIdTimelineRoute: AuthBundleIdTimelineRoute,
  AuthExportBundleIdRoute: AuthExportBundleIdRoute,
  AuthExportJobIdRoute: AuthExportJobIdRoute,
  AuthHistoryBundleIdRoute: AuthHistoryBundleIdRoute,
  AuthTruckIdCargoRoute: AuthTruckIdCargoRoute,
  AuthTruckIdDriveRoute: AuthTruckIdDriveRoute,
  AuthTruckIdTimelineRoute: AuthTruckIdTimelineRoute,
  AuthVenueIdGateRoute: AuthVenueIdGateRoute,
  AuthVenueIdServiceRoute: AuthVenueIdServiceRoute,
  AuthWasteIdCargoRoute: AuthWasteIdCargoRoute,
  AuthWasteIdTimelineRoute: AuthWasteIdTimelineRoute,
  AuthCompanyIdIndexRoute: AuthCompanyIdIndexRoute,
  AuthVenueIdIndexRoute: AuthVenueIdIndexRoute,
  AuthSurchargeScIdCargoRoute: AuthSurchargeScIdCargoRoute,
  AuthVenueIdInspectBundleRoute: AuthVenueIdInspectBundleRoute,
  AuthVenueIdInspectWasteRoute: AuthVenueIdInspectWasteRoute,
  AuthVenueIdSuperviseBundleRoute: AuthVenueIdSuperviseBundleRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
